import { FlexGrid, Responsive } from '@dcl/ui';
import React from 'react'
import { Leftnav } from './components/LeftNav/Leftnav';
import { ILeftNavArticle } from './types';
import ReactHtmlParser from 'react-html-parser';
import { DESKTOP_MIN_WIDTH, MOBILE_MAX_WIDTH } from '../../constants';
import { LeftNavMobile } from './components/LeftNavMobile/LeftNavMobile';

export const LeftNavArticle: React.FC<ILeftNavArticle> = (props) => {
    const { leftNavItems, leftNavContent } = props;

    const scrollToId = (id: string) => {
        const element = document.getElementById(id);
        element && element.scrollIntoView({ behavior: 'smooth' });
    }

    return (
        <FlexGrid>
            <FlexGrid.Row>
                <FlexGrid.Col xs={12} lg={3} md={12}>
                <Responsive minWidth={DESKTOP_MIN_WIDTH}>
                    <Leftnav leftNavItems={leftNavItems} scrollToId={scrollToId} />
                    </Responsive>
                
                    <Responsive minWidth={0} maxWidth={MOBILE_MAX_WIDTH}>
                        <LeftNavMobile leftNavItems={leftNavItems} scrollToId={scrollToId} />
                    </Responsive>
                </FlexGrid.Col>
                <FlexGrid.Col xs={12} lg={9} md={12}>
                    {ReactHtmlParser(leftNavContent)}
                </FlexGrid.Col>
            </FlexGrid.Row>
        </FlexGrid>

    )
}

LeftNavArticle.displayName = 'LeftNavArticle';